export default {"src":"/_next/static/image/public/images/ic_upload_purple.464d0cb1fea8860d639abeb825c21750.svg","height":16,"width":16};